module.exports = __webpack_public_path__ + "static/img/head-bg-en.dd510e00.png";